import { z } from "zod";
import { BaseEvent } from "./base";
export const PJSDivCheck_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.pjs.v1.PJSDivCheck_Complete"),
    event: z.object({
        url: z.string(),
        totalElements: z.number(),
        notFoundElements: z.number(),
        paywallId: z.string().optional(),
        applicationId: z.string().optional(),
        elements: z.array(z.object({
            innerHTML: z.string()
        }))
    })
});
